import React from 'react';

export const CardTitle = ({ children }) => (
  <h3 className="card-title">{children}</h3>
);

export const CardBody = ({ children }) => (
  <div className="card-body">
    <div className="card-body-inside">{children}</div>
  </div>
);

export const Plus = ({ children }) => (
  <div className="plan-plus">
    <i className="plus" aria-hidden="true" />
    {children}
  </div>
);
